import { ResultsState } from 'enums'
import { DefaultTheme } from 'styled-components'

export const getStatusIconColor = (status: ResultsState, theme: DefaultTheme) => {
  switch (status) {
    case ResultsState.Complete:
      return theme.color.feedback.success.default
    case ResultsState.PendingVerification:
      return theme.color.feedback.warning.default
    case ResultsState.Rejected:
      return theme.color.feedback.danger.default
    case ResultsState.Preparing:
      return theme.color.content.subtle
    case ResultsState.Processing:
      return theme.color.feedback.action.default
    case ResultsState.Failed:
      return theme.color.feedback.danger.default
    default:
      return theme.color.content.main
  }
}
